export const BLOG_DEMO = [
  {
    id: 'pst_01', slug: 'drop-eutanasia-detras-del-concepto',
    title: 'Drop Eutanasia — detrás del concepto',
    excerpt: 'Una colección que explora los estados intermedios entre vigilia y sueño.',
    coverImage: 'https://picsum.photos/seed/blog1/1200/600',
    status: 'published',
    publishedAt: '2026-04-22T10:00:00.000Z',
    author: { name: 'Centrio Studios' }, readingTime: 6,
    blocks: [
      { id: 'bl_1', type: 'text',    html: '<p>El drop nace de una pregunta simple: ¿qué pasa con el cuerpo cuando deja de pelear?</p>' },
      { id: 'bl_2', type: 'heading', level: 2, text: 'Conceptos visuales' },
      { id: 'bl_3', type: 'text',    html: '<p>Texturas crudas, hilos visibles, contraste alto y mucha tipografía.</p>' },
    ],
    seo: { title: 'Drop Eutanasia', description: 'La historia detrás del drop' },
  },
  {
    id: 'pst_02', slug: 'guia-de-tallas-2026',
    title: 'Guía de tallas 2026',
    excerpt: 'Toda la métrica que necesitas para acertar tu fit.',
    coverImage: 'https://picsum.photos/seed/blog2/1200/600',
    status: 'published',
    publishedAt: '2026-03-15T11:00:00.000Z',
    author: { name: 'Centrio Studios' }, readingTime: 4,
    blocks: [{ id: 'bl_1', type: 'text', html: '<p>Tabla de medidas por talla y producto. Largo, ancho, manga.</p>' }],
    seo: { title: 'Guía de tallas', description: 'Talla correcta en cada producto' },
  },
  {
    id: 'pst_03', slug: 'lookbook-anatomy',
    title: 'Lookbook ANATOMY',
    excerpt: 'Editorial del drop ANATOMY con cinco siluetas clave.',
    coverImage: 'https://picsum.photos/seed/blog3/1200/600',
    status: 'draft',
    publishedAt: null,
    author: { name: 'Centrio Studios' }, readingTime: 3,
    blocks: [],
    seo: { title: 'ANATOMY Lookbook', description: '' },
  },
  {
    id: 'pst_04', slug: 'cuidado-y-lavado-prendas-tecnicas',
    title: 'Cómo cuidar tus prendas técnicas',
    excerpt: 'Lavado, secado y guardado: la guía corta para que tu drop dure.',
    coverImage: 'https://picsum.photos/seed/blog4/1200/600',
    status: 'published',
    publishedAt: '2026-02-28T08:30:00.000Z',
    author: { name: 'Centrio Studios' }, readingTime: 5,
    blocks: [
      { id: 'bl_1', type: 'heading', level: 2, text: 'Lavado' },
      { id: 'bl_2', type: 'text',    html: '<p>Agua fría, ciclo corto, del revés. Nunca con químicos blanqueadores.</p>' },
      { id: 'bl_3', type: 'heading', level: 2, text: 'Secado' },
      { id: 'bl_4', type: 'text',    html: '<p>A la sombra, plano. La secadora destruye el algodón pesado.</p>' },
    ],
    seo: { title: 'Cuidado de prendas — Demo', description: 'Cómo extender la vida útil de tus prendas Centrio Studios.' },
  },
  {
    id: 'pst_05', slug: 'making-of-tracksuit-osmosis',
    title: 'Making of: Tracksuit Ósmosis',
    excerpt: 'Del bocetado a la pasarela. 4 meses, 18 prototipos, 1 silueta final.',
    coverImage: 'https://picsum.photos/seed/blog5/1200/600',
    status: 'published',
    publishedAt: '2026-04-05T14:00:00.000Z',
    author: { name: 'Centrio Studios' }, readingTime: 8,
    blocks: [
      { id: 'bl_1', type: 'text', html: '<p>El tracksuit empezó como una respuesta al ruido del street: queríamos volumen sin pesadez.</p>' },
      { id: 'bl_2', type: 'image', src: 'https://picsum.photos/seed/sketch/800/500', alt: 'Boceto inicial' },
      { id: 'bl_3', type: 'text', html: '<p>El primer prototipo era 30% más ancho. Lo bajamos hasta dar con el equilibrio.</p>' },
    ],
    seo: { title: 'Making of Ósmosis', description: 'Proceso creativo del tracksuit Ósmosis.' },
  },
  {
    id: 'pst_06', slug: 'restock-mayo-2026-camisetas',
    title: 'Restock mayo 2026 — Camisetas',
    excerpt: 'Las dos camisetas más vendidas vuelven al catálogo. Cantidades limitadas.',
    coverImage: 'https://picsum.photos/seed/blog6/1200/600',
    status: 'published',
    publishedAt: '2026-05-02T09:00:00.000Z',
    author: { name: 'Centrio Studios' }, readingTime: 2,
    blocks: [{ id: 'bl_1', type: 'text', html: '<p>Reemplazos con el mismo gramaje y la misma estampa. Tallas S a XL.</p>' }],
    seo: { title: 'Restock camisetas', description: 'Vuelven los modelos más pedidos.' },
  },
  {
    id: 'pst_07', slug: 'colaboracion-artistas-locales',
    title: 'Colaboración con artistas locales',
    excerpt: 'Por qué la próxima colección la hacemos con tres tatuadores de Bogotá.',
    coverImage: 'https://picsum.photos/seed/blog7/1200/600',
    status: 'draft',
    publishedAt: null,
    author: { name: 'Centrio Studios' }, readingTime: 6,
    blocks: [
      { id: 'bl_1', type: 'text', html: '<p>El plan: cada artista interviene una pieza base con un trazo propio.</p>' },
    ],
    seo: { title: 'Colab artistas', description: '' },
  },
  {
    id: 'pst_08', slug: 'envios-internacionales-disponibles',
    title: 'Ahora enviamos a México, Argentina y Chile',
    excerpt: 'Costos de envío, tiempos y aduana — todo lo que tenés que saber.',
    coverImage: 'https://picsum.photos/seed/blog8/1200/600',
    status: 'published',
    publishedAt: '2026-04-12T16:00:00.000Z',
    author: { name: 'Centrio Studios' }, readingTime: 4,
    blocks: [
      { id: 'bl_1', type: 'heading', level: 2, text: 'Costos' },
      { id: 'bl_2', type: 'text',    html: '<p>Tarifa plana de $89.000 COP a cualquier país de la región. Free shipping en compras +$500K.</p>' },
      { id: 'bl_3', type: 'heading', level: 2, text: 'Tiempos' },
      { id: 'bl_4', type: 'text',    html: '<p>5–9 días hábiles vía Coordinadora Internacional.</p>' },
    ],
    seo: { title: 'Envíos LATAM', description: 'Ya enviamos a México, Argentina y Chile.' },
  },
]
